(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel', 'torso/modules/mixins/loadingMixin'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/NestedModel'), require('backbone-torso/modules/mixins/loadingMixin'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel, loadingMixin) {
  'use strict';

  /**
   * Model for feature configuration information.
   *
   * @class FeatureConfigModel
   * @extends Torso.NestedModel
   * @constructor
   */

  /**
   * @property CONFIG_LEVEL {Object} Enum of the different config levels (MINIMAL, NORMAL or FULL).
   *   @property CONFIG_LEVEL.MINIMAL {String} Minimal config level - most things turned off.
   *   @property CONFIG_LEVEL.NORMAL {String} Normal config level - used in most of portal.
   *   @property CONFIG_LEVEL.FULL {String} Full config level - mainly for full admin access.
   */
  var CONFIG_LEVEL = {
    MINIMAL: 'minimal',
    NORMAL: 'normal',
    FULL: 'full'
  };

  var FeatureConfigModel = TorsoNestedModel.extend({
    CONFIG_LEVEL: CONFIG_LEVEL,

    /**
     * Extends the loadingMixin's methods with a method that both fetches (if not already fetched or fetching) and
     * returns a promise that will resolve once the fetch completes (or immediately if already fetched).
     * @returns {$.Deferred.Promise}
     */
    loadOnce: function() {
      if (!this.loadedOnce && !this.loading) {
        this.fetch(arguments);
      } else {
        this.trigger('load-complete');
      }
      return this.getLoadedOncePromise();
    },

    /**
     * @param configLevel {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isEnabled: function(configLevel) {
      var featureEnabled = this.get('enabled'),
          configLevelEnabled = this.get(configLevel + '.enabled');
      return featureEnabled && configLevelEnabled;
    },

    /**
     * Convenience function for getting normal level config
     *
     * @method isEnabledNormalLevel
     * @return {Boolean} true if feature is enabled for normal level
     */
    isEnabledNormalLevel: function() {
      return this.isEnabled(CONFIG_LEVEL.NORMAL);
    },

    /**
     * Fetches the feature config and resolves to whether the given config level is enabled (true) or disabled (false).
     * @method isEnabledPromise
     * @param configLevel {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {jQuery.Deferred.Promise} that resolves to true if the config level is enabled, and false otherwise.
     */
    isEnabledPromise: function(configLevel) {
      var thisFeatureConfigModel = this;
      return this.loadOnce()
        .then(function() {
          return thisFeatureConfigModel.isEnabled(configLevel);
        });
    }
  });

  FeatureConfigModel = FeatureConfigModel.extend(loadingMixin(FeatureConfigModel));
  FeatureConfigModel.CONFIG_LEVEL = CONFIG_LEVEL;

  return FeatureConfigModel;
}));
